"use strict";

angular.module("core")
.constant("semver", require("node_modules/semver"))



//////////////////
// WEBPACK FOOTER
// ./core/semver/semver.constant.js
// module id = 377
// module chunks = 0